export default __webpack_public_path__ + "static/media/38.a19c7df4.jpg";